import {
  ADD_DAILY_COMMISSION_FAIL,
  ADD_DAILY_COMMISSION_REQUEST,
  ADD_DAILY_COMMISSION_RESET,
  ADD_DAILY_COMMISSION_SUCCESS,
  GET_DAILY_COMMISSIONS_FAIL,
  GET_DAILY_COMMISSIONS_REQUEST,
  GET_DAILY_COMMISSIONS_RESET,
  GET_DAILY_COMMISSIONS_SUCCESS,
  GET_DAILY_COMMISSION_BY_ID_FAIL,
  GET_DAILY_COMMISSION_BY_ID_REQUEST,
  GET_DAILY_COMMISSION_BY_ID_RESET,
  GET_DAILY_COMMISSION_BY_ID_SUCCESS,
  UPDATE_DAILY_COMMISSION_FAIL,
  UPDATE_DAILY_COMMISSION_REQUEST,
  UPDATE_DAILY_COMMISSION_RESET,
  UPDATE_DAILY_COMMISSION_SUCCESS,
  DELETE_DAILY_COMMISSION_FAIL,
  DELETE_DAILY_COMMISSION_REQUEST,
  DELETE_DAILY_COMMISSION_RESET,
  DELETE_DAILY_COMMISSION_SUCCESS,
  GET_COMMISSION_SUMMARY_FAIL,
  GET_COMMISSION_SUMMARY_REQUEST,
  GET_COMMISSION_SUMMARY_RESET,
  GET_COMMISSION_SUMMARY_SUCCESS,
  UPDATE_EVIDENCE_STATUS_REQUEST,
  UPDATE_EVIDENCE_STATUS_SUCCESS,
  UPDATE_EVIDENCE_STATUS_FAIL,
  UPDATE_EVIDENCE_STATUS_RESET,
  BULK_UPDATE_EVIDENCE_STATUS_REQUEST,
  BULK_UPDATE_EVIDENCE_STATUS_SUCCESS,
  BULK_UPDATE_EVIDENCE_STATUS_FAIL,
  BULK_UPDATE_EVIDENCE_STATUS_RESET,
  EXPORT_DAILY_COMMISSIONS_REQUEST,
  EXPORT_DAILY_COMMISSIONS_SUCCESS,
  EXPORT_DAILY_COMMISSIONS_FAIL,
} from '../constants/dailyCommissionConstant.js';

export const addDailyCommissionReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_DAILY_COMMISSION_REQUEST:
      return { loading: true }
    case ADD_DAILY_COMMISSION_SUCCESS:
      return { loading: false, success: true, commission: action.payload }
    case ADD_DAILY_COMMISSION_FAIL:
      return { loading: false, error: action.payload }
    case ADD_DAILY_COMMISSION_RESET:
      return {}
    default:
      return state
  }
}

export const getDailyCommissionsReducer = (state = { commissions: [], pagination: null }, action) => {
  switch (action.type) {
    case GET_DAILY_COMMISSIONS_REQUEST:
      return { ...state, loading: true }
    case GET_DAILY_COMMISSIONS_SUCCESS:
      return {
        loading: false,
        commissions: action.payload,
        pagination: action.pagination || null
      }
    case GET_DAILY_COMMISSIONS_FAIL:
      return { loading: false, error: action.payload, commissions: [], pagination: null }
    case GET_DAILY_COMMISSIONS_RESET:
      return { commissions: [], pagination: null }
    default:
      return state
  }
}

export const getDailyCommissionByIdReducer = (state = { commission: {} }, action) => {
  switch (action.type) {
    case GET_DAILY_COMMISSION_BY_ID_REQUEST:
      return { loading: true, ...state }
    case GET_DAILY_COMMISSION_BY_ID_SUCCESS:
      return { loading: false, commission: action.payload }
    case GET_DAILY_COMMISSION_BY_ID_FAIL:
      return { loading: false, error: action.payload }
    case GET_DAILY_COMMISSION_BY_ID_RESET:
      return { commission: {} }
    default:
      return state
  }
}

export const updateDailyCommissionReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_DAILY_COMMISSION_REQUEST:
      return { loading: true }
    case UPDATE_DAILY_COMMISSION_SUCCESS:
      return { loading: false, success: true, commission: action.payload }
    case UPDATE_DAILY_COMMISSION_FAIL:
      return { loading: false, error: action.payload }
    case UPDATE_DAILY_COMMISSION_RESET:
      return {}
    default:
      return state
  }
}

export const deleteDailyCommissionReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_DAILY_COMMISSION_REQUEST:
      return { loading: true }
    case DELETE_DAILY_COMMISSION_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case DELETE_DAILY_COMMISSION_FAIL:
      return { loading: false, error: action.payload }
    case DELETE_DAILY_COMMISSION_RESET:
      return {}
    default:
      return state
  }
}

export const getCommissionSummaryReducer = (state = { summary: {} }, action) => {
  switch (action.type) {
    case GET_COMMISSION_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case GET_COMMISSION_SUMMARY_SUCCESS:
      return { loading: false, summary: action.payload }
    case GET_COMMISSION_SUMMARY_FAIL:
      return { loading: false, error: action.payload }
    case GET_COMMISSION_SUMMARY_RESET:
      return { summary: {} }
    default:
      return state
  }
}

// ===== NEW: Evidence Status Update Reducer =====
export const updateEvidenceStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_EVIDENCE_STATUS_REQUEST:
      return { loading: true }
    case UPDATE_EVIDENCE_STATUS_SUCCESS:
      return { loading: false, success: true, commission: action.payload }
    case UPDATE_EVIDENCE_STATUS_FAIL:
      return { loading: false, error: action.payload }
    case UPDATE_EVIDENCE_STATUS_RESET:
      return {}
    default:
      return state
  }
}

export const bulkUpdateEvidenceStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_UPDATE_EVIDENCE_STATUS_REQUEST:
      return { loading: true }
    case BULK_UPDATE_EVIDENCE_STATUS_SUCCESS:
      return { loading: false, success: true, result: action.payload }
    case BULK_UPDATE_EVIDENCE_STATUS_FAIL:
      return { loading: false, error: action.payload }
    case BULK_UPDATE_EVIDENCE_STATUS_RESET:
      return {}
    default:
      return state
  }
}

export const exportDailyCommissionsReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_DAILY_COMMISSIONS_REQUEST:
      return { loading: true }
    case EXPORT_DAILY_COMMISSIONS_SUCCESS:
      return { loading: false, success: true }
    case EXPORT_DAILY_COMMISSIONS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}